import Drawer, { DrawerProps } from 'rc-drawer';
import { useEffect, useState } from 'react';

const drawerMotion = (placement: DrawerProps['placement']) => ({
  motionAppear: true,
  motionEnter: true,
  motionLeave: true,
  motionName: `panel-motion-${placement}`,
  motionDeadline: 350,
});

const maskMotion: DrawerProps['maskMotion'] = {
  motionAppear: true,
  motionEnter: true,
  motionLeave: true,
  motionName: 'mask-motion',
  motionDeadline: 350,
};

interface ResponsiveDrawerProps {
  isHelpDrawerOpen: boolean;
  closeDrawer: () => void;
  children: React.ReactNode;
}

export default function ResponsiveDrawer({ isHelpDrawerOpen, closeDrawer, children }: ResponsiveDrawerProps) {
  const [isDesktop, setIsDesktop] = useState(() => window.innerWidth >= 768);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const placement = isDesktop ? 'left' : 'bottom';
  return (
    <Drawer
      key={isDesktop ? `desktop-${placement}` : `mobile-${placement}`}
      open={isHelpDrawerOpen}
      onClose={closeDrawer}
      placement={placement}
      getContainer="body"
      mask={true}
      keyboard={true}
      width={isDesktop ? 375 : undefined}
      // height={!isDesktop ? "70vh" : undefined}
      motion={drawerMotion(placement)}
      maskMotion={maskMotion}
      styles={{
        content: { background: 'transparent', padding: 0 },
        wrapper: { background: 'transparent' },
      }}
    >
      {children}
    </Drawer>
  );
}
